import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { adminNavigation } from '../navigation'

export function RouteMetadata() {
  const { pathname } = useLocation()
  const item = adminNavigation
    .flatMap(({ items }) => items)
    .find(({ to }) => pathname === to)
  let title = item?.label ?? 'Fant ikke siden'
  if (pathname === '/news/new') title = 'Opprett nyhet'
  else if (/^\/news\/[^/]+\/edit$/.test(pathname)) title = 'Rediger nyhet'
  else if (/^\/news\/[^/]+$/.test(pathname)) title = 'Nyhetsdetaljer'
  else if (/^\/labs\/\d+$/.test(pathname)) title = 'Laboratoriedetaljer'
  else if (/^\/schemas\/[^/]+$/.test(pathname)) title = 'Registreringsskjemaer'
  else if (/^\/edit-sample\/[^/]+$/.test(pathname)) title = 'Rediger prøve'
  else if (pathname === '/login') title = 'Logg inn'
  else if (pathname === '/unauthorized') title = 'Ingen tilgang'

  useEffect(() => {
    document.title = `${title} | Prøveadmin`
  }, [title])

  return <Outlet />
}
